import { useSEO } from "../lib/useSEO";
import PageHero from "../components/layout/PageHero";
import CTASection from "../components/CTASection";
import Icon from "../components/Icon";
import { useConsultation } from "../components/Consultation";
import { Reveal } from "../components/motion/Reveal";
import { SERVICES } from "../data/static";

export default function Services() {
  useSEO(
    "Services — Suvera Academy",
    "Education counselling, course and university selection, application support, scholarship and visa guidance, and pre- and post-departure support."
  );
  const openConsultation = useConsultation();

  return (
    <main data-testid="services-page">
      <PageHero
        eyebrow="Our Services"
        title="More Than Admissions"
        description="Nine connected services covering your entire journey — from the first counselling conversation to settling into your new destination."
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Services" }]}
        testid="services-hero"
      />

      <section className="mx-auto max-w-[1440px] px-4 py-16 sm:px-6 lg:px-10 lg:py-24">
        <div className="space-y-6" data-testid="services-list">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id}>
              <article
                id={s.id}
                className="grid scroll-mt-28 grid-cols-1 gap-6 rounded-2xl border border-slate-200 bg-white p-7 transition-[box-shadow,border-color] duration-300 hover:border-navy/25 hover:shadow-[0_20px_50px_-16px_rgba(13,24,51,0.15)] sm:p-10 lg:grid-cols-12"
                data-testid={`service-section-${s.id}`}
              >
                <div className="flex items-start gap-5 lg:col-span-4">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-navy/5 text-navy">
                    <Icon name={s.icon} className="h-6 w-6" />
                  </span>
                  <div>
                    <p className="font-mono-accent text-[10px] uppercase tracking-[0.22em] text-slate-400">Service {String(i + 1).padStart(2, "0")}</p>
                    <h2 className="mt-1.5 font-display text-2xl font-semibold text-navy-dark">{s.title}</h2>
                  </div>
                </div>
                <div className="lg:col-span-5">
                  <p className="text-sm leading-relaxed text-slate-600 sm:text-base">{s.long}</p>
                  <ul className="mt-4 space-y-2">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-center gap-2.5 text-sm text-slate-700">
                        <Icon name="CheckCircle2" className="h-4 w-4 shrink-0 text-dot-green" />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex items-end lg:col-span-3 lg:justify-end">
                  <button
                    onClick={openConsultation}
                    className="inline-flex items-center gap-2 rounded-full border border-navy/20 px-6 py-3 text-sm font-semibold text-navy transition-colors duration-200 hover:bg-navy hover:text-white"
                    data-testid={`service-enquire-${s.id}`}
                  >
                    Enquire
                    <Icon name="ArrowRight" className="h-4 w-4" />
                  </button>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
      <CTASection />
    </main>
  );
}
